'use strict';

import template from './registrationForm.component.html';

export const RegistrationFormComponent = {
	bindings: {},
	controller: RegistrationFormComponentCtrl,
	controllerAs: 'vm',
	template: template,
};

RegistrationFormComponentCtrl.$inject = [
	'$q',
	'$scope',
	'mx.sb.DialogView.DialogFactory',
	'mx.shell.EventService',
	'mx.shell.Config',
	'mx.shell.UserProfileService',
	'mx.shell.AuthService',
];

export function RegistrationFormComponentCtrl($q, $scope, dialogFactory, eventService, mxConfig, userProfileService, authService) {
	const vm = this;

	async function init() {
		const userInfo = await userProfileService.get();

		vm.view = dialogFactory.createEditDialog(
			{
				_id: userInfo.objectId,
				_type: 'SPSUserType',
			},
			{
				Id: '7097acb1-d98a-c398-3ac6-08d920347f57',
			}
		);

		vm.view.finishDefer = $q.defer();

		vm.view.finishDefer.promise.then((/*entity*/) => {
			hideForm();
			window.location = mxConfig.get('basePath');
		});
	}

	init();

	function hideForm() {
		const form = document.getElementById('user-registration-form');
		form.style.display = 'none';
	}

	eventService.subscribeTo(
		mx.SolutionBuilderAgent.Events.ObjectDataChanged,
		function (e, { view }) {
			if (view === vm.view) {
				hideForm();
			}
		},
		$scope
	);

	eventService.subscribeTo(
		mx.SolutionBuilderAgent.Events.ViewDataLoaded,
		function (e, view) {
			if (view === vm.view) {
				vm.loaded = true;

				vm.userNameForPasswordsManager = vm.view.context?.SPSUserClassBase?.MailAddress;
				if (!vm.userNameForPasswordsManager) {
					console.error('Unable to set username autocomplete field. Browser Passwords Manager might work not properly.');
				}
			}
		},
		$scope
	);

	vm.save = function save() {
		vm.loaded = false;
		eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.DialogActionExecuted, {
			view: vm.view,
			action: 2,
		});
	};

	vm.cancel = function cancel() {
		authService.logout();
	};
}
